/* mitojs/vue version ' + 3.1.21-bate.1 */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var nativeToString = Object.prototype.toString;
function isType(type) {
    return function (value) {
        return nativeToString.call(value) === "[object ".concat(type, "]");
    };
}
var variableTypeDetection = {
    isNumber: isType("Number"),
    isString: isType("String"),
    isBoolean: isType("Boolean"),
    isNull: isType("Null"),
    isUndefined: isType("Undefined"),
    isSymbol: isType("Symbol"),
    isFunction: isType("Function"),
    isObject: isType("Object"),
    isArray: isType("Array"),
    isProcess: isType("process"),
    isWindow: isType("Window"),
    isNative: isType("Object"),
    isElectronGlobal: isType("global")
};

var isNodeEnv = variableTypeDetection.isProcess(typeof process !== 'undefined' ? process : 0);
var isWxMiniEnv = variableTypeDetection.isObject(typeof wx !== 'undefined' ? wx : 0) &&
    variableTypeDetection.isFunction(typeof App !== 'undefined' ? App : 0);
var isBrowserEnv = variableTypeDetection.isWindow(typeof window !== 'undefined' ? window : 0);
var isElectronGlobalEnv = variableTypeDetection.isElectronGlobal(typeof window !== 'undefined' ? window : 0);
var isNative = variableTypeDetection.isNative(typeof window !== 'undefined' ? window : 0);
function getGlobal() {
    if (isBrowserEnv || isElectronGlobalEnv || isNative)
        return window;
    if (isWxMiniEnv)
        return wx;
    if (isNodeEnv)
        return process;
}
var _global = getGlobal();
var _support = getGlobalMitoSupport();
function getGlobalMitoSupport() {
    _global.__MITO__ = _global.__MITO__ || {};
    return _global.__MITO__;
}

var PREFIX = 'MITO Logger';
var Logger = (function () {
    function Logger() {
        var _this = this;
        this.enabled = false;
        this._console = {};
        _global.console = console || _global.console;
        if (console || _global.console) {
            var logType = ['log', 'debug', 'info', 'warn', 'error', 'assert'];
            logType.forEach(function (level) {
                if (!(level in _global.console))
                    return;
                _this._console[level] = _global.console[level];
            });
        }
    }
    Logger.prototype.disable = function () {
        this.enabled = false;
    };
    Logger.prototype.bindOptions = function (debug) {
        this.enabled = debug ? true : false;
    };
    Logger.prototype.enable = function () {
        this.enabled = true;
    };
    Logger.prototype.getEnableStatus = function () {
        return this.enabled;
    };
    Logger.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        (_a = this._console).log.apply(_a, __spreadArray(["".concat(PREFIX, "[Log]:")], args, false));
    };
    Logger.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        (_a = this._console).warn.apply(_a, __spreadArray(["".concat(PREFIX, "[Warn]:")], args, false));
    };
    Logger.prototype.error = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this._console).error.apply(_a, __spreadArray(["".concat(PREFIX, "[Error]:")], args, false));
    };
    return Logger;
}());
_support.logger || (_support.logger = new Logger());

function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
function getUrlWithEnv() {
    if (isWxMiniEnv)
        return getCurrentRoute();
    if (isBrowserEnv)
        return getLocationHref();
    return '';
}
function getTimestamp() {
    return Date.now();
}
function silentConsoleScope(callback) {
    callback();
}
function getBigVersion(version) {
    return Number(version.split('.')[0]);
}
function setUrlQuery(url, query) {
    var queryArr = [];
    Object.keys(query).forEach(function (k) {
        queryArr.push("".concat(k, "=").concat(query[k]));
    });
    if (url.indexOf('?') !== -1) {
        url = "".concat(url, "&").concat(queryArr.join('&'));
    }
    else {
        url = "".concat(url, "?").concat(queryArr.join('&'));
    }
    return url;
}
function getCurrentRoute() {
    if (!variableTypeDetection.isFunction(getCurrentPages)) {
        return '';
    }
    var pages = getCurrentPages();
    if (!pages.length) {
        return 'App';
    }
    var currentPage = pages.pop();
    return setUrlQuery(currentPage.route, currentPage.options);
}
function getObjectWithForIn(obj) {
    if (!variableTypeDetection.isObject(obj))
        return obj;
    var result = {};
    for (var key in obj) {
        result[key] = obj[key];
    }
    return result;
}

var Severity;
(function (Severity) {
    Severity["Else"] = "else";
    Severity["Error"] = "error";
    Severity["Warning"] = "warning";
    Severity["Info"] = "info";
    Severity["Debug"] = "debug";
    Severity["Low"] = "low";
    Severity["Normal"] = "normal";
    Severity["High"] = "high";
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
(function (Severity) {
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
            case 'log':
            case 'assert':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case Severity.Low:
            case Severity.Normal:
            case Severity.High:
            case Severity.Critical:
            case 'error':
                return Severity.Error;
            default:
                return Severity.Else;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));

function vue2VmHandler(vm) {
    var componentName = '';
    if (vm.$root === vm) {
        componentName = 'root';
    }
    else {
        var name_1 = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
        componentName =
            (name_1 ? 'component <' + name_1 + '>' : 'anonymous component') +
                (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
    }
    return {
        componentName: componentName,
        propsData: vm.$options && vm.$options.propsData
    };
}
function vue3VmHandler(vm) {
    var componentName = '';
    if (vm.$root === vm) {
        componentName = 'root';
    }
    else {
        console.log(vm.$options);
        var name_2 = vm.$options && vm.$options.name;
        componentName = name_2 ? 'component <' + name_2 + '>' : 'anonymous component';
    }
    return {
        componentName: componentName,
        propsData: getObjectWithForIn(vm.$props)
    };
}

var vuePlugin = {
    name: "vue",
    monitor: function (notify) {
        var Vue = this.options.vue;
        if (Vue && Vue.config) {
            var originErrorHandle_1 = Vue.config.errorHandler;
            Vue.config.errorHandler = function (err, vm, info) {
                var data = {
                    type: "VUE",
                    message: "".concat(err.message, "(").concat(info, ")"),
                    level: Severity.Normal,
                    url: getUrlWithEnv(),
                    name: err.name,
                    stack: err.stack || [],
                    time: getTimestamp()
                };
                notify("vue", { data: data, vm: vm });
                var hasConsole = typeof console !== 'undefined';
                if (hasConsole && !Vue.config.silent) {
                    silentConsoleScope(function () {
                        console.error('Error in ' + info + ': "' + err.toString() + '"', vm);
                        console.error(err);
                    });
                }
                return originErrorHandle_1 === null || originErrorHandle_1 === void 0 ? void 0 : originErrorHandle_1(err, vm, info);
            };
        }
    },
    transform: function (_a) {
        var collectedData = _a.data, vm = _a.vm;
        var Vue = this.options.vue;
        if (variableTypeDetection.isString(Vue === null || Vue === void 0 ? void 0 : Vue.version)) {
            switch (getBigVersion(Vue === null || Vue === void 0 ? void 0 : Vue.version)) {
                case 2:
                    return __assign(__assign({}, collectedData), vue2VmHandler(vm));
                case 3:
                    return __assign(__assign({}, collectedData), vue3VmHandler(vm));
                default:
                    return collectedData;
            }
        }
    },
    consumer: function (data) {
        var breadcrumbStack = this.breadcrumb.push({
            type: "Vue",
            category: "exception",
            data: data,
            level: Severity.Error
        });
        this.transport.send(data, breadcrumbStack);
    }
};

export { vuePlugin };
/* follow me on Gitlab! @tangjunkai */
//# sourceMappingURL=vue.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hltn/mitojs-vue/dist/vue.esm.js
// module id = f3V5
// module chunks = 7